import angular from 'angular';
import { dynamicSort } from '@/shared/utils/dynamicSort';

angular.module('cloudX').directive('cxEnumCheckboxSelect', [
  'enumCacheSvc',
  '$filter',
  '$rootScope',
  function(enumCacheSvc, $filter, $rootScope) {
    return {
      restrict: 'E',
      require: '^ngModel',
      template: `<div class="dropdown" uib-dropdown is-open="ddwOpen" auto-close="outsideClick" on-toggle="toggleDropDown(open)">
                  <div class="input-group">
                    <input type="text" class="form-control form-control-readonly" readonly ng-value="displayValue" ng-focus="ddwOpen=true" ng-click="ddwOpen=true; $event.stopPropagation(); $event.preventDefault();" autocomplete="off" placeholder="{{placeholder}}" />
                    <div class="input-group-btn">
                      <button class="btn btn-default dropdown-toggle" ng-if="displayValue==''" uib-dropdown-toggle>
                        <span class="caret"></span>
                      </button>
                      <button class="btn btn-default" ng-if="displayValue!=''" ng-click="clearSelected()">
                        <span class="fa fa-times"></span>
                      </button>
                    </div>
                  </div>
                  <ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu role="menu" style="max-height:200px;overflow-y:auto">
                    <li ng-repeat="item in items | orderBy:(orderByLabel?\'label\':\'key\') track by item.key">
                      <a href ng-click="toggleItem(item)">
                        <i class="fa margin5R" ng-class="item.selected?'fa-check-square-o':'fa-square-o'"></i><span ng-bind="item.label"></span>
                      </a>
                    </li>
                  </ul>
                </div>`,
      scope: {
        type: '@',
        orderByLabel: '@?',
        placeholder: '@?',
        hideItems: '=?',
      },
      link: function(scope, el, attrs, ngModel) {
        if (!ngModel) return;
        scope.items = [];
        scope.initOnload = null;
        scope.displayValue = '';
        scope.ddwOpen = false;

        enumCacheSvc.get(scope.type).then(function(data) {
          scope.items = (scope.hideItems && scope.hideItems.length > 0
            ? data.filter(x => !scope.hideItems.includes(x.key))
            : data
          ).map(x => ({
            ...x,
            selected: scope.initOnload && scope.initOnload.indexOf(x.key) >= 0,
          }));
          translateLabels();
        });

        function translateLabels() {
          scope.items.forEach(function(item) {
            item.label = $filter('translateList')(item.key, scope.type, item.value);
          });
          scope.setDisplayValue();
        }
        var deregistration = $rootScope.$on('$translateChangeSuccess', translateLabels);
        scope.$on('$destroy', deregistration);

        scope.toggleItem = function(item) {
          item.selected = !item.selected;
          scope.setDisplayValue();
        };

        scope.setDisplayValue = function() {
          scope.displayValue = scope.items
            .filter(x => x.selected)
            .sort(dynamicSort(scope.orderByLabel ? 'label' : 'key'))
            .map(x => x.label)
            .join(', ');
        };
        scope.clearSelected = function() {
          if (scope.items) {
            scope.items.forEach(x => {
              x.selected = false;
            });
          }
          scope.displayValue = '';
          ngModel.$setViewValue([]);
          scope.ddwOpen = false;
        };

        scope.toggleDropDown = function(open) {
          if (!open) {
            const value = scope.items
              .filter(x => x.selected)
              .map(x => x.key)
              .sort();
            ngModel.$setViewValue(value);
          }
        };

        ngModel.$render = function() {
          const value = ngModel.$viewValue || [];
          if (scope.items && scope.items.length) {
            if (value.length) {
              scope.items.forEach(x => {
                x.selected = value && value.indexOf(x.key) >= 0;
              });
              scope.setDisplayValue();
            } else {
              scope.clearSelected();
            }
          } else {
            scope.initOnload = value;
          }
        };
      },
    };
  },
]);
